<ng-container
  *ngTemplateOutlet="
    groupContainer;
    context: {
      $implicit: {
        title: 'Report Builder',
        reports: reportBuilderReports$ | async,
        isLoading: isLoading().reportBuilder,
        icon: 'ts_graph-bar',
        url: '/reporting/list',
      },
    }
  "
></ng-container>
<ng-container
  *ngTemplateOutlet="
    groupContainer;
    context: {
      $implicit: {
        title: 'PDF Reports',
        reports: pdfReports$ | async,
        isLoading: isLoading().pdfReports,
        icon: 'ts_file-info-alt',
        url: '/reports',
      },
    }
  "
></ng-container>

<ng-container
  *ngTemplateOutlet="
    groupContainer;
    context: {
      $implicit: {
        title: 'Dashboards',
        reports: dashboards$ | async,
        isLoading: isLoading().dashboards,
        icon: 'ts_create-dashboard',
        url: '/dashboard',
      },
    }
  "
></ng-container>
<ng-template #groupContainer let-data>
  <div class="group">
    <div class="header">
      <ts-icon [icon]="data.icon" size="small" class="info-icon"></ts-icon> <span>{{ data.title }}</span>
      <ts-icon icon="open_in_new" size="small" class="navigate-icon" [routerLink]="data.url" (click)="onNavigate.emit()"></ts-icon>
    </div>
    <ts-divider spacing="none"></ts-divider>
    <ts-tree-menu
      sidenav
      [suppressHeader]="true"
      [items]="data.reports ?? []"
      [loading]="isLoading().reportBuilder"
      [delegateLeafClickFn]="delegateLeafClickFn.bind(this)"
      [smallSkeleton]="true"
    ></ts-tree-menu>
  </div>
</ng-template>
